import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UndoIcon from "@mui/icons-material/Undo";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// swal
import Swal from "sweetalert2";

// Components
import MuiHeader from "../../components/MuiHeader";

import {
  getAllModules,
  createAllModules,
  updateModules,
  deleteModules,
  getAllSubModules,
  createAllSubModules,
  updateSubModules,
  deleteSubModules,
  getAllTopics,
  createAllTopics,
  updateTopics,
  deleteTopics,
} from "./TrainingModuleThunk";

const TrainingModule = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------
  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];

  const navigate_to = () => {
    navigate("/trainingactivity");
  };

  const [language, setLanguage] = useState("");
  const [usertype, setUsertype] = useState("");
  const [modules, setModules] = useState([]);
  //console.log("modules-------------------->", modules);
  const [moduleid, setModuleid] = useState("");
  const [submodules, setSubmodules] = useState([]);
  const [submoduleid, setSubmoduleid] = useState("");
  const [topics, setTopics] = useState([]);
  const [topicid, setTopicid] = useState("");
  const [moduleorder, setModuleorder] = useState("");
  // //console.log("moduleorder------>", moduleorder);
  const [modulename, setModulename] = useState("");
  // //console.log("modulename------>", modulename);
  const [submoduleOrder, setSubmoduleOrder] = useState("");
  const [submoduleName, setSubmoduleName] = useState("");
  const [topicOrder, setTopicOrder] = useState("");
  const [topicName, setTopicName] = useState("");
  //console.log("topicName------>", topicName);
  const [disable_content_button, set_disable_content] = useState(true);

  const language_select_onchange = (event) => {
    setLanguage(event.target.value);
  };
  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
    const body = {
      usertype: event.target.value,
      language: language,
    };
    getAllModules(body).then((modules) => {
      // //console.log("modules------>", modules.data);
      setModules(modules.data);
    });
  };

  const modulename_select_onchange = (event) => {
    setModuleid(event.target.value);
    const body = {
      usertype: usertype,
      language: language,
      moduleid: event.target.value,
    };
    getAllSubModules(body).then((submodules) => {
      // //console.log("submodules------>", submodules.data);
      setSubmodules(submodules.data);
    });
  };

  const submodule_select_onchange = (event) => {
    setSubmoduleid(event.target.value);
    const body = {
      usertype: usertype,
      language: language,
      moduleid: moduleid,
      submoduleid: event.target.value,
    };
    getAllTopics(body).then((topics) => {
      //console.log("topics------>", topics.data);
      setTopics(topics.data);
    });
  };

  // const topic_select_onchange = (event) => {
  //   setTopicid(event.target.value);
  // };

  // -----------Module create, update delete button click ----------
  //on create module

  const moduleorder_select_onchange = (event) => {
    setModuleorder(event.target.value);
  };

  const module_select_onChange = (event) => {
    setModulename(event.target.value);
  };

  const handleModuleSave = () => {
    const data = {
      usertype: usertype,
      trainingType: "training",
      moduleid: new Date().getTime(),
      modulename: modulename,
      moduleOrder: moduleorder,
    };
    //console.log("data------------>", data);
    if (
      moduleorder === undefined ||
      moduleorder === null ||
      moduleorder.length <= 0 ||
      modulename === undefined ||
      modulename === null ||
      modulename.length <= 0
    )
      alert("Check all the fields");
    else {
      createAllModules(data).then((res) => {
        //console.log(res, "response");
        if (res.data.status == "success") {
          const body = {
            usertype: usertype,
            language: language,
          };
          getAllModules(body).then((modules) => {
            //console.log(modules.data, "modules");
            setModules(modules.data);
            // alert("success");
            toast.success("Changes made successfully");
            setModuleorder("");
            setModulename("");
          });
        }
      });
    }
  };

  const handleModuleUpdate = (element) => {
    //console.log(element, "edited");
    Swal.fire({
      title: "UPDATE Module",
      input: "text",
      inputValue: element.modulename,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === element.modulename) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid module name");
        else {
          //update function
          const data = {
            moduleid: element.moduleid,
            modulename: input_value,
          };
          //console.log("update module-=----->", data);
          updateModules(data).then((response) => {
            if (response.data.status == "success") {
              const body = {
                usertype: usertype,
                language: language,
              };
              getAllModules(body).then((modules) => {
                //console.log(modules.data, "modules");
                setModules(modules.data);
                toast.success("Changes made successfully");
              });
            }
          });
        }
      },
    });
  };

  const handleModuleDelete = (element) => {
    //console.log(element, "on delete");
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteModules(element.moduleid).then((result) => {
          if (result.data.status == "success") {
            const body = {
              usertype: usertype,
              language: language,
            };
            getAllModules(body).then((modules) => {
              //console.log(modules.data, "modules");
              setModules(modules.data);
              toast.success("Changes made successfully");
            });
          }
        });
      }
    });
  };

  //-----------------------------------------------------------------------

  //On Create Sub-module update and delete

  const submoduleOrder_select_onChange = (event) => {
    setSubmoduleOrder(event.target.value);
  };

  const submoduleName_select_onChange = (event) => {
    setSubmoduleName(event.target.value);
  };

  const handleSubmoduleSave = () => {
    const data = {
      usertype: usertype,
      trainingType: "training",
      moduleid: moduleid,
      submoduleid: new Date().getTime(),
      submodulename: submoduleName,
      submoduleOrder: submoduleOrder,
    };
    if (
      submoduleOrder === undefined ||
      submoduleOrder === null ||
      submoduleOrder.length <= 0 ||
      submoduleName === undefined ||
      submoduleName === null ||
      submoduleName.length <= 0
    )
      alert("check all the fields");
    else {
      createAllSubModules(data).then((response) => {
        if (response.data.status == "success") {
          const data = {
            usertype: usertype,
            language: language,
            // moduleId: selModuleDetails.moduleid,
            moduleid: moduleid,
          };
          getAllSubModules(data).then((submodules) => {
            //console.log(submodules.data, "modules");
            setSubmodules(submodules.data);
            setSubmoduleOrder("");
            setSubmoduleName("");
            toast.success("Changes made successfully");
          });
        }
      });
    }
  };

  const handleSubModuleUpdate = (element) => {
    //console.log(element, "edited");
    Swal.fire({
      title: "UPDATE SubModule",
      input: "text",
      inputValue: element.submodulename,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === element.submodulename)
          toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid sub-module name");
        else {
          //update function
          const data = {
            submoduleid: element.submoduleid,
            submodulename: input_value,
          };
          //console.log("update submodule-=----->", data);
          updateSubModules(data).then((response) => {
            if (response.data.status == "success") {
              const data = {
                usertype: usertype,
                language: language,
                // moduleId: selModuleDetails.moduleid,
                moduleid: moduleid,
              };
              getAllSubModules(data).then((submodules) => {
                //console.log(submodules.data, "modules");
                setSubmodules(submodules.data);
                toast.success("Changes made successfully");
              });
            }
          });
        }
      },
    });
  };

  const handleSubModuleDelete = (element) => {
    //console.log(element, "on delete");
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const data = {
          id: element._id,
          submoduleid: element.submoduleid,
        };
        deleteSubModules(element.submoduleid).then((result) => {
          if (result.data.status == "success") {
            const data = {
              usertype: usertype,
              language: language,
              // moduleId: selModuleDetails.moduleid,
              moduleid: moduleid,
            };
            getAllSubModules(data).then((submodules) => {
              //console.log(submodules.data, "modules");
              setSubmodules(submodules.data);
              toast.success("Changes made successfully");
            });
          }
        });
      }
    });
  };

  //----------------------------------------------------------------------

  //on create Topic

  const topicOrder_select_onchange = (event) => {
    setTopicOrder(event.target.value);
  };

  const topicName_select_onchange = (event) => {
    setTopicName(event.target.value);
  };

  const handleTopicSave = () => {
    const data = {
      usertype: usertype,
      trainingType: "training",
      moduleid: moduleid,
      submoduleid: submoduleid,
      topicid: new Date().getTime(),
      topicname: topicName,
      topicOrder: topicOrder,
    };
    if (
      topicOrder === undefined ||
      topicOrder === null ||
      topicOrder.length <= 0 ||
      topicName === undefined ||
      topicName === null ||
      topicName.length <= 0
    )
      alert("check all the fields");
    else {
      createAllTopics(data).then((response) => {
        if (response.data.status == "success") {
          const data = {
            usertype: usertype,
            language: language,
            moduleid: moduleid,
            submoduleid: submoduleid,
          };
          getAllTopics(data).then((topic) => {
            //console.log("topic.data---->", topic.data);
            setTopics(topic.data);
            setTopicOrder("");
            setTopicName("");
            toast.success("Changes made successfully");
          });
        }
      });
    }
  };

  const handleTopicUpdate = (element) => {
    //console.log(element, "edited topic");
    Swal.fire({
      title: "UPDATE SubModule",
      input: "text",
      inputValue: element.topicname,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === element.topicname) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid sub-module name");
        else {
          //update function
          const data = {
            topicid: element.topicid,
            topicname: input_value,
          };
          //console.log("update submodule-=----->", data);
          updateTopics(data).then((response) => {
            if (response.data.status == "success") {
              const data = {
                usertype: usertype,
                language: language,
                moduleid: moduleid,
                submoduleid: submoduleid,
              };
              getAllTopics(data).then((topic) => {
                //console.log("topic.data---->", topic.data);
                setTopics(topic.data);
                toast.success("Changes made successfully");
              });
            }
          });
        }
      },
    });
  };

  const handleTopicDelete = (element) => {
    //console.log(element, "on delete");
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteTopics(element.topicid).then((result) => {
          if (result.data.status == "success") {
            const data = {
              usertype: usertype,
              language: language,
              moduleid: moduleid,
              submoduleid: submoduleid,
            };
            getAllTopics(data).then((topic) => {
              //console.log("topic.data---->", topic.data);
              setTopics(topic.data);
              toast.success("Changes made successfully");
            });
          }
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Training Module/Sub-module" />
        <div style={{ marginTop: "80px" }}>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Language</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={language}
              label="Language"
              onChange={language_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {language_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Usertype</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={usertype}
              label="Language"
              onChange={usertype_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            onClick={navigate_to}
            variant="outlined"
            sx={{
              m: 1,
              minWidth: 90,
              marginTop: -8.8,
              // backgroundColor: "blue",
              // color: "black",
            }}
            size="small"
          >
            <UndoIcon style={{ color: "orange" }}></UndoIcon>
            Back
          </Button>

          <div style={{ display: "flex", marginLeft: "150px" }}>
            <div style={{ padding: "10px" }}>
              <Box
                component="form"
                // sx={{
                //   m: 2,
                //   border: "1px solid grey",
                //   borderRadius: "10px",
                //   width: "430px",
                //   backgroundColor: "lightblue",
                // }}
                // noValidate
                // autoComplete="off"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "16px",
                  borderRadius: "10px",
                  backgroundColor: "#b5d8f5",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="Order"
                    variant="outlined"
                    type="number"
                    InputProps={{
                      inputProps: {
                        max: 100,
                        min: 0,
                      },
                    }}
                    sx={{
                      width: 70,
                      marginTop: 1,
                      marginBottom: 1,
                      marginRight: 1,
                      marginLeft: 1,
                    }}
                    size="small"
                    value={moduleorder}
                    onChange={moduleorder_select_onchange}
                  />
                  <TextField
                    id="outlined-basic"
                    label="Module"
                    variant="outlined"
                    sx={{
                      width: 120,
                      marginTop: 1,
                      marginBottom: 1,
                      marginRight: 1,
                      marginLeft: 1,
                    }}
                    size="small"
                    value={modulename}
                    onChange={module_select_onChange}
                  />

                  <Button
                    sx={{
                      width: 70,
                      marginTop: 1,
                      marginBottom: 1,
                      marginRight: 1,
                      marginLeft: 1,
                    }}
                    variant="contained"
                    onClick={handleModuleSave}
                  >
                    SAVE
                  </Button>
                </div>

                <Box
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#b5d8f5",
                    overflowX: "auto",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      marginTop: "50px",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      {modules.map((element, i) => (
                        <tr key={i}>
                          <td
                            // style={{
                            //   borderCollapse: "collapse",
                            //   width: "20px",
                            //   padding: "5px",
                            //   textAlign: "center",
                            //   verticalAlign: "middle",
                            // }}
                            style={{
                              padding: "8px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {element.moduleOrder}.
                          </td>
                          <td
                            // style={{
                            //   borderCollapse: "collapse",
                            //   wordBreak: "break-all",
                            //   padding: "5px",
                            // }}
                            style={{ padding: "8px", wordBreak: "break-all" }}
                          >
                            {element.modulename}
                          </td>
                          <td
                            // style={{
                            //   borderCollapse: "collapse",
                            //   textAlign: "center",
                            // }}
                            style={{ padding: "9px" }}
                          >
                            <Button onClick={() => handleModuleUpdate(element)}>
                              <EditIcon style={{ color: "blue" }}></EditIcon>
                            </Button>
                          </td>
                          <td
                            // style={{
                            //   borderCollapse: "collapse",
                            //   padding: "5px",
                            //   textAlign: "center",
                            // }}
                            style={{ padding: "8px" }}
                          >
                            <Button
                              // style={{
                              //   marginLeft: "-15px",
                              //   padding: "5px",
                              //   backgroundColor: "transparent",
                              // }}
                              onClick={() => handleModuleDelete(element)}
                            >
                              <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </Box>
            </div>
            <div style={{ padding: "10px" }}>
              <Box
                component="form"
                sx={{
                  display: "flex",
                  marginLeft: "20px",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "16px",
                  borderRadius: "10px",
                  backgroundColor: "#b5d8f5",
                }}
              >
                <FormControl
                  sx={{ width: "265px", marginBottom: "16px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Modules</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={moduleid}
                    label="Age"
                    onChange={modulename_select_onchange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {modules.map((element) => (
                      <MenuItem key={element.moduleid} value={element.moduleid}>
                        {element.modulename}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="Order"
                    sx={{ width: "70px", marginRight: "8px" }}
                    size="small"
                    variant="outlined"
                    type="number"
                    InputProps={{
                      inputProps: {
                        max: 100,
                        min: 0,
                      },
                    }}
                    value={submoduleOrder}
                    onChange={submoduleOrder_select_onChange}
                  />

                  <TextField
                    id="outlined-basic"
                    label="SubModule"
                    sx={{ width: "110px", marginRight: "8px" }}
                    size="small"
                    variant="outlined"
                    value={submoduleName}
                    onChange={submoduleName_select_onChange}
                  />

                  <Button
                    variant="contained"
                    sx={{ width: "70px", marginRight: "8px" }}
                    onClick={handleSubmoduleSave}
                  >
                    SAVE
                  </Button>
                </div>

                <Box
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#b5d8f5",
                    overflowX: "auto",
                  }}
                >
                  <table
                    style={{
                      marginTop: "10px",
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      {submodules.map((element, i) => (
                        <tr key={i}>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {element.submoduleOrder}.
                          </td>
                          <td
                            style={{ padding: "8px", wordBreak: "break-all" }}
                          >
                            {element.submodulename}
                          </td>
                          <td style={{ padding: "9px" }}>
                            <Button
                              onClick={() => handleSubModuleUpdate(element)}
                            >
                              <EditIcon style={{ color: "blue" }} />
                            </Button>
                          </td>
                          <td style={{ padding: "8px" }}>
                            <Button
                              onClick={() => handleSubModuleDelete(element)}
                            >
                              <DeleteIcon style={{ color: "red" }} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </Box>
            </div>
            <div style={{ padding: "10px" }}>
              <Box
                component="form"
                // style={styles.select}
                // noValidate
                // autoComplete="off"
                sx={{
                  display: "flex",
                  marginLeft: "20px",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "16px",
                  borderRadius: "10px",
                  // backgroundColor: "#f5f5f5",
                  backgroundColor: "#b5d8f5",
                }}
              >
                <div>
                  {/* <FormControl
                // style={{ marginLeft: 100 }}
                sx={{ m: 1, width: 140 }}
                size="small"
              > */}
                  <FormControl
                    sx={{ width: "265px", marginBottom: "16px" }}
                    size="small"
                  >
                    <InputLabel id="demo-select-small">Sub-Modules</InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      value={submoduleid}
                      label="Age"
                      onChange={submodule_select_onchange}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {submodules.map((option) => (
                        <MenuItem key={option.submoduleid} value={option}>
                          {option.submodulename}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {/* <div style={{ marginLeft: 130, marginTop: -63 }}>
                 */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="Order"
                    // sx={{
                    //   width: 70,
                    //   marginTop: 2,
                    //   marginBottom: 1,
                    //   marginRight: 1,
                    //   marginLeft: 6,
                    // }}
                    sx={{ width: "70px", marginRight: "8px" }}
                    size="small"
                    variant="outlined"
                    type="number"
                    InputProps={{
                      inputProps: {
                        max: 100,
                        min: 0,
                      },
                    }}
                    value={topicOrder}
                    onChange={topicOrder_select_onchange}
                  />

                  <TextField
                    // style={{ marginTop: 12 }}
                    // sx={{
                    //   width: 110,
                    //   marginTop: 2,
                    //   marginBottom: 1,
                    //   marginRight: 1,
                    // }}
                    sx={{ width: "110px", marginRight: "8px" }}
                    size="small"
                    id="outlined-basic"
                    label="Topic "
                    variant="outlined"
                    value={topicName}
                    onChange={topicName_select_onchange}
                  />

                  <Button
                    // style={{ marginTop: -19, marginRight: -82 }}
                    // sx={{
                    //   // width: 70,
                    //   marginTop: 2,
                    //   marginBottom: 1,
                    //   marginRight: 2,
                    // }}
                    sx={{ width: "70px", marginRight: "8px" }}
                    variant="contained"
                    onClick={handleTopicSave}
                  >
                    SAVE
                  </Button>
                </div>

                <Box
                  sx={{
                    borderRadius: "10px",
                    // backgroundColor: "#fff",
                    backgroundColor: "#b5d8f5",
                    // overflowX: "auto",
                  }}
                >
                  <table
                    style={{
                      // marginTop: 12,
                      // border: "1px solid black",
                      marginTop: "10px",
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      {topics.map((element, i) => (
                        <tr key={i}>
                          <td
                            // style={{
                            //   textAlign: "left",
                            //   // border: "1px solid black",
                            //   borderCollapse: "collapse",
                            // }}
                            style={{
                              padding: "8px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {element.topicOrder}.
                          </td>
                          <td
                            // style={{
                            //   textAlign: "left",
                            //   // border: "1px solid black",
                            //   borderCollapse: "collapse",
                            //   wordBreak: "break-all",
                            // }}
                            style={{ padding: "8px", wordBreak: "break-all" }}
                          >
                            {element.topicname}
                          </td>
                          <td
                            // style={{
                            //   // border: "1px solid black",
                            //   borderCollapse: "collapse",
                            // }}
                            style={{ padding: "10px" }}
                          >
                            <Button
                              // style={{ marginLeft: 25, marginRight: 12 }}
                              // variant="contained"
                              onClick={() => handleTopicUpdate(element)}
                            >
                              <EditIcon style={{ color: "blue" }}></EditIcon>
                            </Button>
                          </td>
                          <td
                            // style={{
                            //   // border: "1px solid black",
                            //   borderCollapse: "collapse",
                            // }}
                            style={{ padding: "8px" }}
                          >
                            <Button
                              // style={{ marginLeft: 25, marginRight: 12 }}
                              // variant="contained"
                              onClick={() => handleTopicDelete(element)}
                            >
                              <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default TrainingModule;

const styles = {
  select: {
    border: "1px solid grey",
    borderRadius: "10px",
    marginTop: "15px",
    marginBottom: "5px",
    marginLeft: "30px",
    width: "462px",
    marginRight: "5px",
    backgroundColor: "lightblue",
  },
  selects: {
    border: "1px solid grey",
    borderRadius: "10px",
    marginTop: "15px",
    marginBottom: "5px",
    marginLeft: "30px",
    width: "422px",
    marginRight: "5px",
    backgroundColor: "lightblue",
  },
};
